import { UserModel } from '../shared/types';
import { baseApi } from './base';

const functionUrl = `${process.env.REACT_APP_FUNCTION_HOST_URL}/api/v1/user`;

export const userApi = {
    getUser: async (): Promise<UserModel> => {
        return baseApi.get(`${functionUrl}`);
    },
};
